$(document).ready(function () {
  var hoverDelay;

  $(".header__inline-menu_hover").hover(
    function () {
      clearTimeout(hoverDelay);
      hoverDelay = setTimeout(function () {
        $(".header__inline-menu_hover").removeClass("hover-active");
        $("body").stop().addClass("header-open", "slow");
        $(this).addClass("hover-active");
        var categoriesElement = $(".block_section-header--categories", this);
      }.bind(this), 150);
    },
    function () {
      clearTimeout(hoverDelay);
      hoverDelay = setTimeout(function () {
        $("body").stop().removeClass("header-open", "slow");
        $(".header__inline-menu_hover").removeClass("hover-active");
        var categoriesElement = $(".block_section-header--categories", this);
      }.bind(this), 150);
    }
  );

  $('.block_section-header--cate-block').each(function () {
    var $block = $(this);
    var $listItems = $block.find('.block_section-header--inner-link li');
    var$listItems = $block.find('.block_section-header--inner-link li a');
  
   $listItems.on('mouseenter', function () {
      var data_link_menu = $(this).find('.block_section-header--child').attr('data-menu-product-title');
      var data_link_menu_image = $(this).find('.block_section-header--image').attr('data-menu-product-image');
      if (data_link_menu === data_link_menu_image) {
        $listItems.removeClass('block-header-inner-active');
        $(this).addClass('block-header-inner-active');
      }
    }).on('mouseleave', function () {
      // Handle mouse leave (if needed)
    });
  
    $listItems.first().addClass('block-header-inner-active');
  });
  

  $('.header__inline-menu_hover').each(function (index) {
    var $menu = $(this);
    if (index >= 2) {
      $menu.find('.plus').remove();
    }
  });

  $('.header__inline-menu_hover:lt(2)').each(function () {
    var $menu = $(this);
    $menu.find('.otherlink .block_section-header--inner-link').hide();
    $menu.find('.otherlink .block_section-header--link-href:first').addClass('active').find('.block_section-header--inner-link').show();
    $menu.find('.plus').on('click', function () {
      var accordion = $(this).closest('.block_section-header--link-href');
      $menu.find('.otherlink .block_section-header--link-href').not(accordion).removeClass('active').find('.block_section-header--inner-link').slideUp();
      accordion.toggleClass('active');
      accordion.find('.block_section-header--inner-link').slideToggle();
    });
  });

  const selectors = { countdownWrapper: ".shippingCountdown", countdownText: ".shippingCountdownText" };
  var daydescriptor, offsetHours, dayofweek = moment().isoWeekday(), hourofday = moment().hour(), minuteofhour = moment().minute(), timezone = moment.tz.guess();
 if ("America/New_York" == timezone) {
    offsetHours = 10.5;
    1 == dayofweek || 2 == dayofweek ? daydescriptor = hourofday < 10.5 ? "tomorrow" : "tomorrow" : 3 == dayofweek ? daydescriptor = hourofday <= 10.5 ? "tomorrow" : "tomorrow" : 4 == dayofweek ? daydescriptor = hourofday < 10.5 ? "tomorrow" : "tomorrow" : 5 == dayofweek ? daydescriptor = hourofday < 10.5 ? "Tuesday" : "Tuesday" : 6 == dayofweek ? daydescriptor = "Tuesday" : 7 == dayofweek && (daydescriptor = "Tuesday");
  } else if ("America/Chicago" == timezone) {
    offsetHours = 9.5;
    1 == dayofweek || 2 == dayofweek || 3 == dayofweek || 4 == dayofweek ? daydescriptor = hourofday < 9.5 ? "tomorrow" : "tomorrow" : 5 == dayofweek ? daydescriptor = hourofday < 9.5 ? "Tuesday" : "Tuesday" : 6 == dayofweek ? daydescriptor = "Tuesday" : 7 == dayofweek && (daydescriptor = "Tuesday");
  } else if ("America/Denver" == timezone) {
    offsetHours = 8.5;
    1 == dayofweek || 2 == dayofweek || 3 == dayofweek || 4 == dayofweek ? daydescriptor = hourofday < 8.5 ? "tomorrow" : "tomorrow" : 5 == dayofweek ? daydescriptor = hourofday < 8.5 ? "Tuesday" : "Tuesday" : 6 == dayofweek ? daydescriptor = "Tuesday" : 7 == dayofweek && (daydescriptor = "Tuesday");
  } else if ("America/Los_Angeles" == timezone) {
    offsetHours = 7.5;
    1 == dayofweek || 2 == dayofweek || 3 == dayofweek || 4 == dayofweek ? daydescriptor = hourofday < 7.5 ? "tomorrow" : "tomorrow" : 5 == dayofweek ? daydescriptor = hourofday < 7.5 ? "Tuesday" : "Tuesday" : 6 == dayofweek ? daydescriptor = "Tuesday" : 7 == dayofweek && (daydescriptor = "Tuesday");
  } else {
    offsetHours = 7.5;
    1 == dayofweek || 2 == dayofweek || 3 == dayofweek || 4 == dayofweek ? daydescriptor = hourofday < 7.5 ? "tomorrow" : "tomorrow" : 5 == dayofweek || 6 == dayofweek ? daydescriptor = "Tuesday" : 7 == dayofweek && (daydescriptor = "Tuesday");
  }
  if (moment().hour() < offsetHours) {
    $(selectors.countdownText).countdown(moment().startOf("date").add(offsetHours, "h").toDate(), function (o) {
      if (o.offset.hours < 1) $(this).html(o.strftime("Order within <strong>%-M min</strong> <strong>%S sec</strong> and it ships <strong>FREE " + daydescriptor + "</strong>."));
      else $(this).html(o.strftime("Order within <strong>%-H hr</strong> <strong>%-M min</strong> and it ships <strong>FREE " + daydescriptor + "</strong>."));
    });
  } else {
    $(selectors.countdownText).countdown(moment().endOf("date").add(0, "h").toDate(), function (o) {
      if (o.offset.hours < 1) $(this).html(o.strftime("<span>Order within <strong>%-M min</strong> <strong>%S sec</strong> and it ships <strong>FREE " + daydescriptor + "</strong>."));
      else $(this).html(o.strftime("Order within <strong>%-H hr</strong> <strong>%-M min</strong> and it ships <strong>FREE " + daydescriptor + "</strong>."));
    });
  }
});